<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          Сведения об удостоверении документа, если он удостоверен
        </div>
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="v.notaryJob.$model"
          :errorMessages="getValidationErrorText(v.notaryJob)"
          label="Должность нотариуса"
          outlined
          disabled
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.notaryRegNumber.$model"
          :errorMessages="getValidationErrorText(v.notaryRegNumber)"
          label="Регистрационный номер нотариуса"
          outlined
          disabled
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.notaryFirstName.$model"
          :errorMessages="getValidationErrorText(v.notaryFirstName)"
          label="Имя"
          outlined
          disabled
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.notaryLastName.$model"
          :errorMessages="getValidationErrorText(v.notaryLastName)"
          label="Фамилия"
          outlined
          disabled
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.notaryPatronymic.$model"
          :errorMessages="getValidationErrorText(v.notaryPatronymic)"
          label="Отчество (при наличии)"
          outlined
          disabled
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';

export const notaryInfoValidation = {
  notaryJob: {},
  notaryRegNumber: {},
  notaryFirstName: {},
  notaryLastName: {},
  notaryPatronymic: {},
};

export const notaryInfoModel = {
  notaryJob: '',
  notaryRegNumber: '',
  notaryFirstName: '',
  notaryLastName: '',
  notaryPatronymic: '',
};

export default {
  name: 'NotaryInfo',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
